/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-fa22eda7.mjs';
import { h } from 'vue';
import { p as pick_1 } from '../_chunks/dep-e524ff2f.mjs';
import { i as isFunction_1 } from '../_chunks/dep-1f286011.mjs';
import { i as isString_1 } from '../_chunks/dep-b390ff23.mjs';
import { i as isArray_1 } from '../_chunks/dep-e9ff4ce8.mjs';
import { i as isNumber_1 } from '../_chunks/dep-af8c0169.mjs';
import '../_chunks/dep-8a0ff305.mjs';
import '../_chunks/dep-34428f12.mjs';
import '../_chunks/dep-16b9f817.mjs';
import '../_chunks/dep-c54c9f32.mjs';
import '../_chunks/dep-c24f5c5d.mjs';
import '../_chunks/dep-1c40d002.mjs';
import '../_chunks/dep-61150968.mjs';
import '../_chunks/dep-0bf03d55.mjs';
import '../_chunks/dep-5b5daf08.mjs';
import '../_chunks/dep-95049222.mjs';
import '../_chunks/dep-3ced59c9.mjs';
import '../_chunks/dep-ac19a2b6.mjs';
import '../_chunks/dep-2a69909d.mjs';
import '../_chunks/dep-6c1f8553.mjs';
import '../_chunks/dep-90d97bcb.mjs';
import '../_chunks/dep-c8679a16.mjs';
import '../_chunks/dep-e09a06d8.mjs';
import '../_chunks/dep-939a74d6.mjs';
import '../_chunks/dep-45572c49.mjs';
import '../_chunks/dep-437754aa.mjs';
import '../_chunks/dep-6dbd6c24.mjs';
import '../_chunks/dep-0f45a6e0.mjs';
import '../_chunks/dep-25b8bf4b.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function getParentsToRoot(element, root) {
  var list = [];
  var el = element;
  while (el && el.parentNode) {
    list.push(el);
    if (el === root) {
      break;
    }
    el = el.parentNode;
  }
  return list;
}
function getParentMarks(name, element, root) {
  var list = getParentsToRoot(element, root);
  return list.map(function (el) {
    var mark = {
      name: name,
      value: el.getAttribute(name) || "",
      el: el
    };
    return mark;
  }).filter(function (mark) {
    return mark.value;
  });
}
function getMark(name, element, root) {
  var list = getParentMarks(name, element, root);
  var info = list.pop() || null;
  return info;
}
function getTNode(prop) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tnode = null;
  var item = null;
  var conf = _objectSpread({}, options);
  if (isFunction_1(prop)) {
    var _conf$node;
    item = prop(h, (_conf$node = conf.node) === null || _conf$node === void 0 ? void 0 : _conf$node.getModel());
  } else if (isString_1(prop)) {
    item = prop;
  }
  if (isString_1(item)) {
    tnode = item;
  } else if (item) {
    tnode = item;
  }
  return tnode;
}
function getLineModel(nodes, node, index) {
  var lineModel = {
    top: false,
    right: false,
    bottom: false,
    left: false
  };
  var nodeChildren = [];
  if (isArray_1(node.children)) {
    nodeChildren = node.children;
  }
  var childNode = nodes[index - 1] || null;
  var nodeItemIndex = childNode ? childNode.getIndex() : 0;
  if (index === 0) {
    lineModel.left = !!node.parent;
    lineModel.bottom = node.children && node.expanded;
    lineModel.right = node.parent && !node.children;
  } else if (index === 1) {
    lineModel.top = true;
    lineModel.right = true;
    lineModel.bottom = nodeItemIndex < nodeChildren.length - 1;
  } else if (nodeItemIndex < nodeChildren.length - 1) {
    lineModel.top = true;
    lineModel.bottom = true;
  }
  return lineModel;
}
function isTreeNodeValue(item) {
  return isString_1(item) || isNumber_1(item);
}
function getNode(store, item) {
  var node = null;
  var val = null;
  if (isString_1(item) || isNumber_1(item)) {
    val = item;
  } else if (item && isTreeNodeValue(item.value)) {
    val = item.value;
  }
  node = store.getNode(val);
  return node;
}
var getStoreConfig = function getStoreConfig(props) {
  var storeProps = pick_1(props, ["keys", "expandAll", "expandLevel", "expandMutex", "expandParent", "activable", "activeMultiple", "disabled", "draggable", "checkable", "checkStrictly", "load", "lazy", "valueMode", "filter", "allowFoldNodeOnFilter"]);
  return storeProps;
};

export { getLineModel, getMark, getNode, getParentMarks, getParentsToRoot, getStoreConfig, getTNode, isTreeNodeValue };
//# sourceMappingURL=util.mjs.map
